module.exports = __webpack_public_path__ + "img/right_arrow.9e839264.svg";